(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adv-c-research-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DIALOG_ID = 'gsW2BiX1ig';
  var TRIGGER_SELECTOR = 'a[href="#el-' + DIALOG_ID + '"], [data-adv-research-open]';

  function getDialog() {
    return document.querySelector('dialog[data-gp-dialog-id="' + DIALOG_ID + '"]');
  }

  function openDialog(trigger) {
    var dialog = getDialog();
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    dialog._advReturnFocus = trigger || document.activeElement;
    dialog.showModal();
  }

  function closeDialog(dialog) {
    if (dialog && dialog.open) {
      dialog.close();
    }
  }

  function onDocumentClick(event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      openDialog(trigger);
      return;
    }

    var closeBtn = event.target.closest('[data-gp-dialog-close]');
    if (closeBtn) {
      closeDialog(closeBtn.closest('dialog'));
      return;
    }

    var overlay = event.target.closest('[data-gp-dialog-overlay]');
    if (overlay) {
      closeDialog(overlay.closest('dialog'));
    }
  }

  function onDialogClose(event) {
    var dialog = event.target;
    var returnFocus = dialog._advReturnFocus;
    dialog._advReturnFocus = null;
    if (returnFocus && typeof returnFocus.focus === 'function') {
      returnFocus.focus();
    }
  }

  function initAll(scope) {
    var root = scope || document;
    var dialogs = root.querySelectorAll('dialog[data-gp-dialog-id="' + DIALOG_ID + '"]');
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i]._advBound) continue;
      dialogs[i]._advBound = true;
      dialogs[i].addEventListener('close', onDialogClose);
    }
  }

  if (!document._advResearchPopupDelegated) {
    document._advResearchPopupDelegated = true;
    document.addEventListener('click', onDocumentClick);
  }

  function ready() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adv-hw01-research-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DIALOG_ID = 'gsW2BiX1ig';
  var TRIGGER_SELECTOR = 'a[href="#el-' + DIALOG_ID + '"], [data-adv-research-open]';

  function getDialog() {
    return document.querySelector('dialog[data-gp-dialog-id="' + DIALOG_ID + '"]');
  }

  function openDialog(trigger) {
    var dialog = getDialog();
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    dialog._advReturnFocus = trigger || document.activeElement;
    dialog.showModal();
  }

  function closeDialog(dialog) {
    if (dialog && dialog.open) {
      dialog.close();
    }
  }

  function onDocumentClick(event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      openDialog(trigger);
      return;
    }

    var closeBtn = event.target.closest('[data-gp-dialog-close]');
    if (closeBtn) {
      closeDialog(closeBtn.closest('dialog'));
      return;
    }

    var overlay = event.target.closest('[data-gp-dialog-overlay]');
    if (overlay) {
      closeDialog(overlay.closest('dialog'));
    }
  }

  function onDialogClose(event) {
    var dialog = event.target;
    var returnFocus = dialog._advReturnFocus;
    dialog._advReturnFocus = null;
    if (returnFocus && typeof returnFocus.focus === 'function') {
      returnFocus.focus();
    }
  }

  function initAll(scope) {
    var root = scope || document;
    var dialogs = root.querySelectorAll('dialog[data-gp-dialog-id="' + DIALOG_ID + '"]');
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i]._advBound) continue;
      dialogs[i]._advBound = true;
      dialogs[i].addEventListener('close', onDialogClose);
    }
  }

  if (!document._advResearchPopupDelegated) {
    document._advResearchPopupDelegated = true;
    document.addEventListener('click', onDocumentClick);
  }

  function ready() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
